//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tabs: { type: Array, required: true },
    activeTabIndex: { type: Number, required: true },
    showOnDesktop: { type: Boolean, required: true }
  },
  computed: {
    classes () {
      return {
        CustomiserTabs: true,
        'CustomiserTabs--show-on-desktop': this.showOnDesktop
      }
    }
  },
  methods: {
    getTabClasses (idx) {
      return {
        CustomiserTabs__tab: true,
        'CustomiserTabs__tab--active': this.activeTabIndex === idx
      }
    }
  }
}
